export default __webpack_public_path__ + "static/media/LabelIconGreen.9948f4b7.svg";